import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Cell } from "recharts";

const CHANNEL_COLORS = {
  meta: "#1877F2",
  google: "#EA4335",
  whatsapp: "#25D366",
  email: "#0C7268",
  direct: "#F54F1B",
  referral: "#4FB3A3",
  unknown: "#8A7F6F",
};

function ChannelTooltip({ active, payload }) {
  if (!active || !payload?.length) return null;
  const row = payload[0].payload;
  return (
    <div className="bg-amtm-surface border border-amtm-border rounded-lg p-2.5 text-sm shadow-sm" data-testid="diwali-channel-tooltip">
      <p className="font-semibold capitalize">{row.channel}</p>
      <p>₹{Number(row.amount).toLocaleString("en-IN")} ({row.share_pct}%)</p>
      <p className="text-amtm-textMuted">{row.donors} donor{row.donors === 1 ? "" : "s"}</p>
    </div>
  );
}

/** Bar chart for data.by_channel off the shared summary payload - amount is
 * the bar height, donors + share % shown in the tooltip and as a legend
 * row underneath each channel label. */
export default function DiwaliChannelChart({ data }) {
  const byChannel = data?.by_channel || [];
  return (
    <div className="bg-amtm-surface border border-amtm-border rounded-xl p-4 mb-6" data-testid="diwali-channel-chart">
      <p className="font-semibold text-amtm-text mb-3">Amount Raised by Channel</p>
      {byChannel.length === 0 ? (
        <p className="text-amtm-textMuted text-sm py-10 text-center" data-testid="diwali-channel-chart-empty">No data for this range yet.</p>
      ) : (
        <>
          <ResponsiveContainer width="100%" height={280}>
            <BarChart data={byChannel}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="channel" fontSize={12} />
              <YAxis fontSize={12} />
              <Tooltip content={<ChannelTooltip />} />
              <Bar dataKey="amount" name="Amount (₹)" radius={[4, 4, 0, 0]}>
                {byChannel.map((row) => (
                  <Cell key={row.channel} fill={CHANNEL_COLORS[row.channel] || "#0C7268"} />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 mt-3" data-testid="diwali-channel-legend">
            {byChannel.map((row) => (
              <div key={row.channel} className="text-xs" data-testid={`diwali-channel-legend-${row.channel}`}>
                <span className="inline-block h-2 w-2 rounded-full mr-1.5" style={{ background: CHANNEL_COLORS[row.channel] || "#0C7268" }} />
                <span className="capitalize font-medium text-amtm-text">{row.channel}</span>
                <span className="text-amtm-textMuted"> · {row.donors} donor{row.donors === 1 ? "" : "s"} · {row.share_pct}%</span>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
